// MODIFIED
import { useState, useCallback } from "react";
import { loanTransactionService } from "../services/loanTransactionService";

export const useLoanTransaction = (showGeneralMessage) => {
  const [requestLoading, setRequestLoading] = useState(false);

  /**
   * Internal fetcher for validation
   */
  const fetchLoanDetails = useCallback(async (type, employeePersonalInformationId) => {
    try {
      const result = await loanTransactionService.getExistingLoanRequest(type, employeePersonalInformationId);
      if (!result?.data) return false;
      return result.data;
    } catch (error) {
      console.error("Error fetching loan request details:", error);
      showGeneralMessage(error?.response?.data || "Error fetching loan request details", false);

      return null;
    }
  }, []);

  const fetchCurrentLoan = useCallback(async (type, employeePersonalInformationId) => {
    try {
      return await loanTransactionService.getCurrentLoan(type, employeePersonalInformationId);
    } catch (error) {
      console.error("Error fetching loan details:", error);
      showGeneralMessage(error?.response?.data || "Error fetching loan details", false);
      return null;
    }
  }, []);

  const fetchEmployeeLoanLogs = useCallback(async (type, employeePersonalInformationId) => {
    try {
      return await loanTransactionService.getEmployeeLoanLogs(type, employeePersonalInformationId);
    } catch (error) {
      console.error("Error fetching loan logs:", error);
      showGeneralMessage(error?.response?.data || "Error fetching loan logs", false);
      return null;
    }
  }, []);


  const handleSaveLoan = async (type, mode, payload, onSuccess) => {
    setRequestLoading(true);
    try {
      console.log({ type, mode, payload });
      await loanTransactionService.save(type, mode, payload);
      showGeneralMessage(`${mode} Loan Request processed successfully!`, true);
      onSuccess?.();
    } catch (error) {
      // Use the error message component structure from your reference
      console.error("Debug Error:", error);
      showGeneralMessage(error?.response?.data || "Error processing loan request", false);
    } finally {
      setRequestLoading(false);
    }
  };

  return {
    requestLoading,
    fetchLoanDetails,
    fetchCurrentLoan,
    fetchEmployeeLoanLogs,
    handleSaveLoan,
  };
};